import { useCallback, useState } from 'react';
import type { AxiosError, AxiosResponse } from 'axios';
import deleteEvent from '../api/deleteEvent';
import { useAuth } from '../context/AuthContext';

const useDeleteEvent = (id: string) => {
  const [response, setResponse] = useState<AxiosResponse | null>(null);
  const [error, setError] = useState<AxiosError | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { logout } = useAuth();

  const deleteData = useCallback(
    (onSuccess: () => void) => {
      setIsLoading(true);
      deleteEvent(id)
        .then(setResponse)
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            logout();
          } else {
            setError(err);
          }
        })
        .finally(() => {
          setIsLoading(false);
          onSuccess();
        });
    },
    [id, logout]
  );

  return { response, error, isLoading, deleteData };
};

export default useDeleteEvent;
